import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import ReportsTable from '../../../components/tables/ReportsTable';

const ReportsOutstanding = () => {
  const generateSampleData = (count = 70) => {
    const riskLevels = ['Low', 'Medium', 'High'];
    const regions = ['Urban', 'Semi-Urban', 'Rural'];

    return Array.from({ length: count }, (_, index) => {
      const outstanding = Math.floor(Math.random() * 28000) + 4000;
      const creditLimit = Math.floor(Math.random() * 40000) + 15000;
      const totalCredit = creditLimit + Math.floor(Math.random() * 32000);
      const totalDebit = totalCredit - outstanding;
      const ageingDays = Math.floor(Math.random() * 35) + 1;
      const utilisation = ((outstanding / creditLimit) * 100).toFixed(1);
      const utilisationRatio = outstanding / creditLimit;
      const risk = utilisationRatio > 0.65 ? 'High' : utilisationRatio > 0.45 ? 'Medium' : 'Low';

      return {
        requestId: `DOUT${String(index + 1).padStart(6, '0')}`,
        retailerCode: `RET${String(Math.floor(Math.random() * 9000) + 1000)}`,
        retailerName: `Retailer ${Math.floor(Math.random() * 220) + 1}`,
        region: regions[Math.floor(Math.random() * regions.length)],
        lastSettlement: new Date(2025, Math.floor(Math.random() * 10), Math.floor(Math.random() * 28) + 1)
          .toISOString()
          .split('T')[0],
        outstanding,
        totalCredit,
        totalDebit,
        creditLimit,
        utilisation,
        ageingDays,
        riskLevel: risk,
        remarks:
          risk === 'High'
            ? 'Escalated to collections team'
            : risk === 'Medium'
            ? 'Payment reminder sent'
            : 'Within threshold',
      };
    });
  };

  const [data] = useState(generateSampleData(85));

  const columns = [
    { key: 'riskLevel', label: 'Risk Level' },
    { key: 'requestId', label: 'Record ID' },
    { key: 'retailerCode', label: 'Retailer Code' },
    { key: 'retailerName', label: 'Retailer Name' },
    { key: 'region', label: 'Region' },
    { key: 'lastSettlement', label: 'Last Settlement' },
    { key: 'totalCredit', label: 'Total Credit (₹)' },
    { key: 'totalDebit', label: 'Total Debit (₹)' },
    { key: 'outstanding', label: 'Outstanding (₹)' },
    { key: 'creditLimit', label: 'Credit Limit (₹)' },
    { key: 'utilisation', label: 'Utilisation %' },
    { key: 'ageingDays', label: 'Ageing (Days)' },
    { key: 'remarks', label: 'Remarks' },
  ];

  return (
    <Container fluid>
      <ReportsTable
        data={data}
        reportType="Distributor_Outstanding"
        columns={columns}
        title="Outstanding Reports"
      />
    </Container>
  );
};

export default ReportsOutstanding;

